import { _genId } from '@ifr/form-questionnaire/src/plugins/formUtilites';
import { axios } from "../plugins/http-axios";
import { Module } from 'vuex';

type TColor = 'success' | 'info' | 'warning' | 'error';
export interface IMessage {
  message: string;
  color?: TColor;
}
interface IDataKeysString {
  [key: string]: string
};
interface IMessageSys extends IMessage {
  key: number;
}
export interface ISystem {
  session?: boolean,
  dDos: boolean,
  textSeconds: number,
};
export class System implements ISystem {
  session?: boolean;
  dDos: boolean;
  textSeconds: number;

  constructor({ session = true,
    dDos = false,
    textSeconds = 0,
  } = {}) {
    this.session = session;
    this.dDos = dDos;
    this.textSeconds = textSeconds;
  }
};
interface IMessageStore {
  storeSuccess: IMessageSys[];
  i18n: IDataKeysString;
  system: ISystem;
  env: IDataKeysString;
}
export default <Module<IMessageStore, any>>{
  state: {
    storeSuccess: [],
    i18n: {},
    system: {
      session: true,
      dDos: false,
      textSeconds: 0,
    },
    env: {},
  },
  mutations: {
    removeSuccess(state, i: number = 0) {
      if (i < state.storeSuccess.length) state.storeSuccess.splice(i, 1);
    },
    addSuccess(state, item: IMessageSys = { key: 0, message: '', color: 'success' }) {
      state.storeSuccess.push(item);
    },
    setI18n(state, data) {
      state.i18n = data;
    },
    setSession(state, data: boolean = false) {
      state.system.session = data;
    },
    setDDos(state, data: ISystem = new System()) {
      state.system.dDos = data.dDos;
      state.system.textSeconds = data.textSeconds;
    },
    setEnv(state, data: IDataKeysString) {
      state.env = data;
    },
  },
  actions: {
    addSuccess({ state, commit }, { message = 'Успешно сохранено!', color = 'success' }: IMessage = <IMessage>{}) {
      const key: number = _genId();
      commit('addSuccess', <IMessage>{ message, key, color });

      setTimeout(() => {
        let j: number = 0;
        const res = state.storeSuccess.find((item, i) => {
          j = i;
          return item.key == key;
        });
        if (res) commit('removeSuccess', j);
      }, 10000);
    },
    getI18n({ state, commit, dispatch, rootGetters }) {
      if (Object.keys(state.i18n).length)
        return true;
      return axios.get(rootGetters.uri.i18n)
        .then(resp => {
          commit('setI18n', resp.data);
          return true;
        })
        .catch(e => {
          e.uri = rootGetters.uri.i18n;
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
    async getEnv({ commit, dispatch, getters, rootGetters }) {
      if (getters.isEnv) return Promise.resolve();
      try {
        const response = await axios.get<IDataKeysString>(rootGetters.uri.env)
        commit('setEnv', response.data);
        return response
      } catch (error) {
        dispatch('setError', error);
        return error;
      }
    },
  },
  getters: {
    storeSuccess: (state): IMessageSys[] => state.storeSuccess,
    voc: state => state.i18n,
    isCloseSession: ({ system }): boolean => !system.session,
    isDDos: ({ system }): boolean => system.dDos,
    getTextSeconds: ({ system }): number => system.textSeconds,
    isEnv: (state): boolean => !!Object.keys(state.env).length,
    env: (state): IDataKeysString => state.env,
    flag:
      (state) =>
      (code: string): boolean|undefined => {
        const flag = Object.keys(state.env).find((key) => key === code);

        //@ts-ignore
        return flag ? state.env[code] : undefined;
      },
  },
};
